import { m } from 'framer-motion';
import { styled, useTheme } from '@mui/material/styles';
import { Container } from '@mui/system';
import { Grid } from '@mui/material';
import { PropTypes } from 'prop-types';
import parse from 'html-react-parser';
//  import { varFade } from '../../animate';
import MotionViewport from '../../animate/MotionViewport';

DetailHTML.propTypes = {
  text: PropTypes.any,
};

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(2, 0),
  backgroundColor: theme.palette.background.paper,
}));

export default function DetailHTML({ text }) {
  const theme = useTheme();

  const options = {
    replace: (domNode) => {
      if (domNode.name === 'a') {
        domNode.attribs.style = `color: ${
          theme.palette.mode === 'light' ? theme.palette.grey[900] : 'rgb(255,196,47)'
        };`;
      }

      if (domNode.attribs && domNode.attribs.style && domNode.name !== 'a') {
        domNode.attribs.style = '';
      }
      if (domNode.name === 'blockquote') {
        domNode.attribs.style = `margin-left: 20px`;
      }
    },
    trim: true,
  };
  return (
    <RootStyle className="printable">
      <Container component={MotionViewport} sx={{ position: 'relative', height: '100%' }}>
        <m.div /*   variants={varFade().inUp}   */>
          <Grid container>
            <Grid
              item
              xs={12}
              className="text-left"
              sx={{
                textAlign: 'justify',
                color: 'text.primary',
              }}
            >
              {parse(text, options)}
            </Grid>
          </Grid>
        </m.div>
      </Container>
    </RootStyle>
  );
}
